export const CSS_CLASSES = {
	BACKDROP: 'survey__backdrop',
	CONTAINER: 'survey__container',
	ICON_BUTTON: 'survey__backdrop__icon-button',
	LINK: 'survey--unobtrusive__link',
};
